export class AppConfig {
  version = '';
}
